import React, { useState } from 'react'
import { DataTableSortableHeader } from '@softwaredev_cegeka/stix-data-table'
import { Menu } from '@softwaredev_cegeka/stix-core/dist/components'
import {
    debouncedLoadData,
    sortObjectToString,
    sortData,
} from 'src/utils/utils'

import EntityTable from './EntityTable'
import './entityTable.scss'

function TenantTable(props) {
    const {
        data,
        companies,
        loading,
        setParams,
        rowSelectHandler,
        params,
        deleteAction,
        ...rest
    } = props
    // Keep sorting and filters in state so we can pass them in every request.
    let [sort, setSort] = useState({ column: null, direction: null })
    const handleColumnSort = columnName => sortingDirection => {
        sortData(columnName, sortingDirection, params, setSort, setParams)
    }
    const columns = [
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'organization_id'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('organization_id')}
                    >
                        Organization ID
                    </DataTableSortableHeader>
                )
            },
            accessor: 'organization_id',
            width: '20%',
        },
        {
            Header: 'Companies',
            accessor: 'companies',
            Cell: ({ cell }) => {
                let parsedCell = cell.value
                    ?.map(item => item.company_name)
                    .join(',')
                return parsedCell ? parsedCell : ''
            },
            width: '20%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'name' ? sort.direction : undefined
                        }
                        onSort={handleColumnSort('name')}
                    >
                        Name
                    </DataTableSortableHeader>
                )
            },
            accessor: 'name',
            width: '30%',
        },
        {
            Header: 'Email domain',
            accessor: 'tenant_domains',
            Cell: ({ cell }) => {
                let parsedCell = cell.value
                    ?.map(item => item.email_domain)
                    .join(',')
                return parsedCell ? parsedCell : ''
            },
            width: '30%',
        },
    ]
    const columnsToFilter = [
        {
            column: 'organization_id',
            label: 'organization id',
        },
        {
            column: 'name',
        },
        {
            column: 'tenant_domains',
            label: 'email domain',
        },
        {
            column: 'company_id',
            label: 'company id',
            options: companies.map(company => {
                return { value: company.id, label: company.name }
            }),
        },
    ]

    const columnsToSearch = ['organization_id', 'name']

    function handleFilterChange(entries) {
        // Reset to show al results after clear filters is clicked.
        if (entries.length === 0) {
            setParams({})
            return
        }

        const sortString = sortObjectToString(sort)

        // Update params with new selected filter and send them back to the route.
        entries.forEach(item => {
            Object.entries(item).forEach(([key, value]) => {
                if (key === 'tenant_domains') {
                    params.email_domain_like = value.toString()
                } else if (key === 'company_id') {
                    params.company_id = value.toString()
                } else {
                    params[key + '_like'] = value.toString()
                }
            })
        })

        if (sortString) {
            params.sort = sortString
        }

        setParams(params)
    }

    function handleGlobalFilter(value) {
        // check all columns on entry
        columnsToSearch.forEach(col => {
            params[col + '_like'] = value.toString()
        })
        params.use_or = true
        debouncedLoadData(params, setParams)
    }

    if (process.env.REACT_APP_ENABLE_EDIT_TENANT_FUNCTIONALITY === 'true') {
        columns.push({
            Header: () => null,
            id: 'menu',
            Cell: selectedRow => (
                <Menu.Option
                    contextMenu={[
                        {
                            name: `Edit tenant`,
                            icon: 'edit',
                            href: '/tenant-form/' + selectedRow.row.original.id,
                        },
                        {
                            name: 'Remove',
                            icon: 'delete',
                            onClick: () => {
                                let r = window.confirm(
                                    `You are permanently removing tenant ${selectedRow.row.original.name}. Are you sure?`
                                )
                                if (r === true) {
                                    deleteAction(
                                        selectedRow.row.original.id,
                                        selectedRow.row.original.name
                                    )
                                }
                            },
                        },
                    ]}
                    icon={'actions-vert'}
                />
            ),
            width: '1%',
        })
    }
    return (
        <EntityTable
            {...rest}
            loading={loading}
            onSingleRowSelect={selectedRowObj => {
                rowSelectHandler(selectedRowObj)
            }}
            data={data}
            columns={columns}
            columnsTofilter={columnsToFilter}
            onColumnFilter={handleFilterChange}
            onGlobalFilter={handleGlobalFilter}
        />
    )
}

export default TenantTable
